window.addEventListener('DOMContentLoaded',function(){
    // $('.mege-menu-custom-lt-item-top').on('click',function(){
    //     $(this).toggleClass('active');
    //     $(this).parent().find('.mege-menu-custom-lt-item-content').slideToggle(300);
    // })

    // $('#menu-drawer-panel-main .menu-level-one:first-child .menu-level-one-title').click();
    $('.menu-level-one .menu-level-one-title').on('click',function(){
        $(this).parent().find('.menu-drawer__panel-body').slideToggle(300)
        $(this).parent().toggleClass('active')
    })
})